import { ChangeEvent, RefObject, SVGProps } from 'react';
import { cn, HiddenFileUploadInput, Loading } from '@sib/ui';
import { Camera } from '@sib/ui/icons';

export interface AvatarUploadSettings {
  handleFileChange: (event: ChangeEvent<HTMLInputElement>) => Promise<void>;
  fileInputRef: RefObject<HTMLInputElement>;
  acceptFiles: string;
  openFileInput: () => void | undefined;
  isLoading: boolean;
}

interface AvatarUploadOverlayProps extends AvatarUploadSettings {
  IconProps?: SVGProps<SVGSVGElement>;
}

export const AvatarUploadOverlay = ({
  handleFileChange,
  fileInputRef,
  acceptFiles,
  openFileInput,
  IconProps,
  isLoading = false,
}: AvatarUploadOverlayProps) => (
  <>
    <HiddenFileUploadInput
      ref={fileInputRef}
      accept={acceptFiles}
      onChange={handleFileChange}
    />
    <div
      onClick={openFileInput}
      className={cn(
        'absolute top-0 left-0 flex h-full w-full cursor-pointer items-center justify-center rounded-full bg-gray-200 opacity-0 transition-opacity group-hover:opacity-100',
        isLoading && 'opacity-100'
      )}
    >
      {isLoading ? (
        <Loading
          {...IconProps}
          className={cn('size-3 text-gray-400', IconProps?.className)}
        />
      ) : (
        <Camera
          {...IconProps}
          className={cn('size-3 text-gray-400', IconProps?.className)}
        />
      )}
    </div>
  </>
);
